import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=193ac2f2&scoped=true&"
import script from "./ClientEdit.vue?vue&type=script&lang=js&"
export * from "./ClientEdit.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=193ac2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ac2f2",
  null
  
)

export default component.exports